import type { FaireProductEntity } from "../../entity_types/product";

export const p_ugzu8dnjc4: FaireProductEntity = {
  token: "p_ugzu8dnjc4",
  type: "product",
  name: "Women's Trailhead 7/8 Leggings",
  brandToken: "b_409pab9jko",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/362b68f047372f1ac857eb388cec755966af1af0bebc9d0c9328da0842d13889.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a32813884caee1325936cf053032981904cb82cf6972cdbb5b1cccb2494a077.png",
    "https://cdn.faire.com/fastly/c7d189d0c2e0df3432913bac60c02bb41845f8ff026fe4c2f5b4a606452fc5fe.png",
    "https://cdn.faire.com/fastly/0285fbdbe56db3e878f25cecf6ba6207950b877cc72fb69df3cf736d2cb95bf1.png",
    "https://cdn.faire.com/fastly/233883443a4c76bc2cb38932c0d2d77733cbd6d2c1b13624c7203e47e28d0c42.png",
    "https://cdn.faire.com/fastly/c2e64b5742bf24a63846ca813da1bc631583f1673677c72c2bb88a87da4fc057.png",
    "https://cdn.faire.com/fastly/c617d90d6c31f128a8ec84f174889dd98351ceb21748fa4e72fdabe29cd3c617.png",
    "https://cdn.faire.com/fastly/7c25415297876105ae6f6d880a0c593841c216aa8c44dd0f23bfcd9b8ee46a9b.jpeg",
    "https://cdn.faire.com/fastly/483ed0ab23edb70fd2b433cab94b154bb4485b4cb9fe165f4296b1ea92ba4104.png",
    "https://cdn.faire.com/fastly/c16f987436d6132cce8f23be5d6cf764f673847acf7eb31ee9198ebfdc0197ae.png",
    "https://cdn.faire.com/fastly/1d0c8843eb8f50beda57fac9557b6d5646f8e23bfc603d6c00127dc3cb28cef4.png",
    "https://cdn.faire.com/fastly/0a39e9114d6c2840f7d9302309d09886bdbae987d9da5619f2ef25814b89e76b.png",
    "https://cdn.faire.com/fastly/ef255198b252bdf0af7a35d440ebb78614ed5e97c544781d585cb06c979c7235.png",
    "https://cdn.faire.com/fastly/a89d4b32b7b4df9a3f5ede5203543c2708b7c4b0cb79679525c6804de3abfb73.png",
    "https://cdn.faire.com/fastly/73b43bd43f419a7a8918826d9b6acd485f9a450238e2346662a981beb83a2f9c.png",
    "https://cdn.faire.com/fastly/2ab8c165e8eef42dabecf698b08daeb49ef5dff11297d3a54d3356db0110d5b4.png",
    "https://cdn.faire.com/fastly/89c6ba08cd3c7863872fc07dbbcc0973acffd9b7b2357f07d6732e85a2f2fc7d.png",
    "https://cdn.faire.com/fastly/a13de1d62b156d1bff67ad4d58d0a2b32fea72eceb3f5d19a3599b630b8a5812.png",
    "https://cdn.faire.com/fastly/1a0054fbcc1a7c63e058960ab5845af2d5d62938642dff60f5d29fcf84060829.png",
    "https://cdn.faire.com/fastly/0e3310e9c18bc997205585144c6def6a3073190432562cf1a90262fc0d89629b.png",
    "https://cdn.faire.com/fastly/35c2d818f47e16b6dc6898818e140fff74d185f8a0d136665b7f86fdf68885af.png",
    "https://cdn.faire.com/fastly/6266f8425b70bda2a897640d785255c03833b882f3bd728b1d5a75c436af9f9b.png",
    "https://cdn.faire.com/fastly/69948c54e58494ebc7c1188fbde157f04831a5d3aeb173918632e1f5bc5517f1.png",
    "https://cdn.faire.com/fastly/26f82f5954a32a3e8cf5b6220c5dc9a845e0132838c4e55233e3c03c60e3480c.png",
  ],
  priceDollars: 51.27,
  description:
    'To the adventurous ones that ask what’s beyond the bend, the courageous ones that take the first step, and the determined ones that don’t know how to stop. Our Trailhead Leggings understand your drive. These multi-pocketed leggings are made with our versatile PrimaFlex materiel that ensures lightweight strength and comfort for any activity. With breathability and compression in mind, these leggings stay opaque and move with you as you enjoy everything that the day has to offer. \n\nFeatures\n\n * High Waisted \n * Inseam Lengths: XS: 24.5", S: 25.5", M: 26.25", L: 26.75", XL: 27" \n * Dyed PrimaFlex™ Body Fabric \n * Compression \n * Side Hip Pockets \n * Soft \n * Breathable \n * Opaque When Stretched \n * Back Hip Pocket \n * Quick-dry \n * Lightweight',
  tags: [],
  msrpDollars: 102.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:39.807Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
